// extracted by mini-css-extract-plugin
export var sponsors = "sponsorlist-module--sponsors--p7ofF";
export var inner = "sponsorlist-module--inner--2EWvL";
export var sponsor_list = "sponsorlist-module--sponsor_list--1QqEJ";
export var platinum = "sponsorlist-module--platinum--Ojb2W";
export var oracle = "sponsorlist-module--oracle--1Apbb";
export var gold = "sponsorlist-module--gold--2Au8n";
export var perks = "sponsorlist-module--perks--10kgA";
export var silver = "sponsorlist-module--silver--1O9Z2";